/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-26 16:32:12
 *
 * LastModified: 2017-05-26 16:32:12
 *-------------------------------------------------------*/

function listStores(state = {}, action) {
	switch (action.type) {
		case 'GET_STORE_LIST_SUCCESS':
			return action.payload;
		default:
			return state;
	}
}

function storeConditionSearch(state = {}, action) {
	switch (action.type) {
		case 'SET_STORE_CONDITION_SEARCH':
			return action.payload;
		default:
			return state;
	}
}

function glassesConditionSearch(state = {}, action) {
	switch (action.type) {
		case 'SET_GLASSES_CONDITION_SEARCH':
			return action.payload;
		default:
			return state;
	}
}

export default {
	listStores,
	storeConditionSearch,
	glassesConditionSearch
};



// WEBPACK FOOTER //
// ./routes/app/routes/stores/reducer/index.js